export default "__VITE_ASSET__BDKnqDf8__"